import { render, staticRenderFns } from "./Cross.vue?vue&type=template&id=b3bfa940"
import script from "./Cross.vue?vue&type=script&lang=js"
export * from "./Cross.vue?vue&type=script&lang=js"
import style0 from "./Cross.vue?vue&type=style&index=0&id=b3bfa940&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports